import { useState } from 'react';

export function DownloadRequirementButton({ runId }: { runId: string }): JSX.Element {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onDownload = async (): Promise<void> => {
    setBusy(true);
    setErr(null);
    try {
      const base = import.meta.env['VITE_API_BASE_URL'] ?? '';
      const token = localStorage.getItem('jwt');
      const url = `${base}/api/v1/pipelines/runs/${encodeURIComponent(runId)}/stages/requirement`;
      const resp = await fetch(url, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });
      if (resp.status === 404) {
        setErr('No requirement recorded');
        return;
      }
      if (!resp.ok) throw new Error(`download failed: ${resp.status}`);
      const blob = await resp.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = filenameFromResponse(resp, 'requirement.md');
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch {
      setErr('Retry download');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid="download-requirement"
      onClick={() => void onDownload()}
      disabled={busy}
      title="Download the requirement this run was given, as Markdown"
      className="shrink-0 h-[28px] px-3 rounded-md border border-border bg-panel text-[11.5px] text-text hover:bg-panel-2 disabled:opacity-50"
    >
      {busy ? 'Downloading…' : (err ?? '↓ Requirement')}
    </button>
  );
}

function filenameFromResponse(resp: Response, fallback: string): string {
  const cd = resp.headers.get('Content-Disposition') ?? '';
  const m = /filename="?([^";]+)"?/i.exec(cd);
  return m?.[1]?.trim() || fallback;
}
